import {
  Component,
  OnInit,
  ElementRef,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
  SecurityContext,
} from '@angular/core'

import { saveAs } from 'file-saver'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { CommonService } from '../../../shared/services/common.service'
import { ShoppingCartService } from '../../cart/cart-shared/cart.service'
import { formatDate, DatePipe } from '@angular/common'
import { Router } from '@angular/router'
import { BulkServiceService } from '../bulk-service.service'
import { HttpEventType, HttpResponse } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms'
import { DomSanitizer } from '@angular/platform-browser'
import { SpinnerOverlayService } from '../../../shared/components/spinner-overlay/spinner-overlay.service'
export const headerOptions = { responseType: 'text' as 'json' }

@Component({
  standalone: false,
  selector: 'vs-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss'],
})
export class BulkUploadComponent implements OnInit {
  selectedFile: any
  public disbledBtn: boolean
  public uploadedFiles
  public bulkOrderPdf
  public orderListObj
  public currentUser
  public savedCartId
  public currentCart
  userType: string
  loggedIn: boolean
  public bulkPostCsvFileObj
  public progress: number = 0
  public myFiles: string[] = []

  public content: any
  public bulkQty: FormGroup = new FormGroup({})
  public quantity = new FormControl('1', [Validators.required])
  public showError: boolean
  public showTextError: boolean
  public incorrectNo: boolean
  public disabledClass: boolean = false
  public uploadArr = []
  fieldArray: Array<any> = [
    {
      name: '',
      qty: '',
    },
  ]
  newAttribute: any = {}
  blob: any
  @ViewChild('fileMaxLenghtExceed', { static: false })
  fileMaxLenghtExceed: ElementRef
  @ViewChild('fileInfo', { static: false }) fileInfo: ElementRef
  @ViewChild('fileSizeExceed', { static: false }) fileSizeExceed: ElementRef
  @ViewChild('fileType', { static: false }) fileType: ElementRef
  @ViewChild('fileDuplicate', { static: false }) fileDuplicate: ElementRef
  progressInfo: any = null
  selectedIndex: any
  //@ViewChild('documentClose')
  //private documentClose: ElementRef;
  constructor(
    public commonService: CommonService,
    private globalMessageService: GlobalMessageService,
    private cartService: ShoppingCartService,
    private bulkservice: BulkServiceService,
    private renderer: Renderer2,
    private router: Router,
    private auth: AuthService,
    private datepipe: DatePipe,
    public spinnerOverlayService: SpinnerOverlayService,
    private domSanitizer: DomSanitizer
  ) {
    this.showError = false
    this.showTextError = false
    this.incorrectNo = false
  }

  ngOnInit(): void {
    this.selectedIndex = sessionStorage['selectedIndex'];

    this.bulkservice.getContent.subscribe((content) => {
      this.content = content
    })
    this.bulkQty.addControl('text' + 0, new FormControl(1, Validators.required))
    this.fieldArray[0].qty = '1'
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.loggedIn = true
          this.userType = 'current'
        } else {
          this.loggedIn = false
          this.userType = 'anonymous'
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    //  this.downloadSaveCart();
  }

  downloadSaveCart() {
    this.spinnerOverlayService.show('')
    const urlparams = [
      'users',
      this.userType,
      'bulkOrders',
      'downloadSampleTemplate',
    ]
    const apiUrl = this.commonService.constructUrl(urlparams)

    this.commonService.getData_CSV(apiUrl, headerOptions).subscribe(
      (res: Blob) => {
        this.spinnerOverlayService.hide()
        //changed comment
        if (res !== null && res !== undefined) {
          const currentDate = this.datepipe.transform(new Date(), 'yyyyMMdd')
          let fileName = 'sample' + currentDate
          // let fileName = 'Sample';
          // const blob = new Blob([res], { type: 'application/vnd.ms.excel' });
          // const file = new File([blob], fileName + '.xlsx', {
          //   type: 'application/vnd.ms.excel',
          // });
          const blob = new Blob([res], { type: 'application/csv' })
          const file = new File([blob], fileName + '.csv', {
            type: 'application/csv',
          })
          saveAs(file)
        } else {
          this.displayDownloadError()
        }
      },
      (error) => {
        this.spinnerOverlayService.hide()

        this.displayDownloadError()
      }
    )
  }
  displayDownloadError() {
    this.globalMessageService.add(
      { key: 'bulkorder.issueDownloadingcsv' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }

  sendOrderList(myFiles, isCSV) {
    const formData = new FormData()
    for (let i = 0; i < myFiles.length; i++) {
      formData.append('csvFile', myFiles[i])
    }
    let fileType = myFiles[0].name.split('.').pop()
    let urlparams

    urlparams = [
      'users',
      this.userType,
      'bulkOrders',
      fileType == 'csv' ? 'uploadCsvTemplate' : 'uploadCartExcel',
    ]

    // this.spinnerOverlayService.show('');
    const apiUrl = this.commonService.constructUrl(urlparams)
    this.commonService
      .uploadFileWithProgress(apiUrl, formData)
      .pipe(
        map((event) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfo = Math.round((100 * event.loaded) / event.total)
            if (this.progressInfo == 100) {
            }
          } else if (event instanceof HttpResponse) {
            // this.fileInfos = this.uploadService.getFiles();

            this.bulkPostCsvFileObj = event.body
            this.bulkservice.sendBulkOrderList(this.bulkPostCsvFileObj)
            this.bulkservice.emitDate(true)
            this.bulkservice.emitFileType(fileType)
            this.router.navigate(['bulk-Table'])
          }
        })
      )
      .subscribe(
        (success) => {},
        (error) => {
          this.progressInfo = null
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            'Error in uploading the file',
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  getFileSize(fileSize) {
    if (Math.round((fileSize / 1024) * 1000) / 1000 >= 1024.0) {
      return (Math.round(fileSize / 1024) / 1024).toFixed(2) + ' mb'
    }
    if (Math.round((fileSize / 1024) * 1000) / 1000 < 1024.0) {
      return (Math.round((fileSize / 1024) * 1000) / 1000).toFixed(2) + ' kb'
    }
  }

  upload(event) {
    let _this = this
    let filesTotal = 0
    let totalUploadedFiles = 0
    let totalFileSize = 0
    let prevFiles: any = 0
    this.myFiles = []
    this.fileMaxLenghtExceed.nativeElement.innerHTML = ''
    this.fileType.nativeElement.innerHTML = ''
    this.fileSizeExceed.nativeElement.innerHTML = ''
    this.fileDuplicate.nativeElement.innerHTML = ''
    let uploadDiv = this.domSanitizer.sanitize(
      SecurityContext.NONE,
      this.fileInfo.nativeElement
    )
    let uploadedFilesCount = document.querySelectorAll('.fileDivID-section')
    let isDuplicateFiles = false
    let allFileNames = []
    for (let j = 0; j < uploadedFilesCount.length; j++) {
      let size = parseInt(uploadedFilesCount[j].getAttribute('data-size'))
      allFileNames.push(uploadedFilesCount[j].getAttribute('data-filename'))
      prevFiles = prevFiles + size
    }
    let totalSize = prevFiles

    if (
      event.target.files.length <= 5 &&
      event.target.files.length + uploadedFilesCount.length <= 5
    ) {
      if (
        event.target.files.length == 5 ||
        event.target.files.length + uploadedFilesCount.length == 5
      ) {
        this.disbledBtn = true
      }
      for (let a = 0; a < event.target.files.length; a++) {
        totalSize += event.target.files[a].size

        allFileNames.forEach((file) => {
          if (event.target.files[a].name == file) {
            this.fileDuplicate.nativeElement.innerHTML = 'File Already exists'
            isDuplicateFiles = true
          }
        })
      }
      let filesMB = Math.round(totalSize / (1024 * 1024)) // in MB
      if (filesMB <= 30) {
        if (!isDuplicateFiles) {
          this.uploadedFiles = []
          for (let i = 0; i < event.target.files.length; i++) {
            let res_field = event.target.files[i].name
            let extension = res_field
              .substr(res_field.lastIndexOf('.') + 1)
              .toLowerCase()
            let allowedExtensions = ['csv', 'xlsx', 'xls']
            totalSize += event.target.files[i].size

            if (allowedExtensions.indexOf(extension) === -1) {
              this.fileType.nativeElement.innerHTML =
                'Imported file must be a text file with CSV/XLS/XLSX extension.'
              this.disbledBtn = false
            } else {
              this.uploadedFiles.push({
                filename: event.target.files[i].name,
                filesize: event.target.files[i].size,
              })

              const fileDiv = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('div')
              )
              this.renderer.setAttribute(
                uploadDiv,
                'class',
                'custom-display-bulk-order'
              )
              this.renderer.appendChild(uploadDiv, fileDiv)
              this.renderer.setAttribute(fileDiv, 'id', 'fileDivID')
              this.renderer.setAttribute(
                fileDiv,
                'class',
                'custom-display-bulk-order'
              )
              this.renderer.setAttribute(
                fileDiv,
                'data-size',
                this.domSanitizer.sanitize(
                  SecurityContext.NONE,
                  event.target.files[i].size
                )
              )
              this.renderer.setAttribute(
                fileDiv,
                'data-filename',
                this.domSanitizer.sanitize(
                  SecurityContext.NONE,
                  event.target.files[i].name
                )
              )
              this.renderer.addClass(fileDiv, 'fileDivID-section')
              const fileIcon = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('i')
              )
              this.renderer.appendChild(fileDiv, fileIcon)
              this.renderer.addClass(fileIcon, 'material-icons')
              this.renderer.addClass(fileIcon, 'material-icons-custom')
              const iconText = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText('receipt')
              )
              this.renderer.appendChild(fileIcon, iconText)
              const fileName = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('p')
              )
              this.renderer.appendChild(fileDiv, fileName)
              this.renderer.setAttribute(fileName, 'id', 'para11')
              const fileNameText = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText(event.target.files[i].name)
              )
              this.renderer.appendChild(fileName, fileNameText)
              const fileSize = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('p')
              )
              this.renderer.appendChild(fileDiv, fileSize)
              this.renderer.setAttribute(fileSize, 'id', 'para22')

              const fileNameSize = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText(
                  ' ' + this.getFileSize(event.target.files[i].size)
                )
              )

              this.renderer.appendChild(fileSize, fileNameSize)
              const closeIcon = this.renderer.createElement('a')
              this.renderer.appendChild(fileDiv, closeIcon)
              this.renderer.setAttribute(closeIcon, 'id', `${i}`)
              this.renderer.setAttribute(
                closeIcon,
                'data-name',
                this.domSanitizer.sanitize(
                  SecurityContext.NONE,
                  event.target.files[i].name
                )
              )
              this.renderer.addClass(closeIcon, 'closeId-img')
              const fileNameClose = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText('X')
              )
              this.renderer.appendChild(closeIcon, fileNameClose)
              closeIcon.addEventListener('click', function (evt) {
                _this.disbledBtn = false
                this.parentElement.remove()

                for (var z = 0; z < totalUploadedFiles; z++) {
                  this.fileMaxLenghtExceed.nativeElement.innerText = ''
                  this.fileType.nativeElement.innerText = ''
                  this.fileSizeExceed.nativeElement.innerText = ''
                  this.fileDuplicate.nativeElement.innerText = ''
                  if (
                    this.getAttribute('data-name') ==
                    _this.uploadedFiles[z].filename
                  ) {
                    prevFiles = 0
                    _this.uploadedFiles.splice(z, 1)
                    totalUploadedFiles = totalUploadedFiles - 1
                  }
                }
              })

              this.myFiles.push(event.target.files[i])
              // this.progress++  ;

              this.sendOrderList(this.myFiles, extension === 'csv')
              totalUploadedFiles = totalUploadedFiles + 1
            }
          } // for ends
        } else {
          this.fileDuplicate.nativeElement.innerHTML = 'File already exists'
          this.disbledBtn = false
        }
      } else {
        this.fileSizeExceed.nativeElement.innerHTML = 'File size exceeded'
        this.disbledBtn = false
      }
    } else {
      this.fileMaxLenghtExceed.nativeElement.innerHTML =
        'You have exceeded files'
    }

    event.target.value = ''
  }

  uploadContent() {
    this.uploadArr = []
    if (
      this.content == null ||
      this.content == '' ||
      this.content == !this.content
    ) {
      this.showTextError = true
    } else {
      const contentArr = this.content.split('\n').flatMap(line => line.trim() || []);
      let contentArr2 = []
      for (let i = 0; i < contentArr.length; i++) {
        if (contentArr[i].length == 0) {
          continue
        } else {
          // this.incorrectNo = true;
          contentArr2 = contentArr[i].split(`,`)
          const obj = {
            productCode: contentArr2[0].trim(),
            quantity: contentArr2[1] ? contentArr2[1].trim() : 1,
            requestedShipDate: '',
            description: contentArr2[2] || '',
          }
          this.uploadArr.push(obj)
        }
      }

      if (!this.incorrectNo) {
        this.bulkservice
          .getBulkCopyPasteList(this.uploadArr, this.userType)
          .subscribe((res) => {
            this.bulkservice.sendBulkOrderList(res)
            this.bulkservice.emitDate(false)
            this.router.navigate(['bulk-Table'])
          })
      }
    }
  }
  addField() {
    this.fieldArray.push(this.newAttribute)
    this.newAttribute = {}
    this.bulkQty.addControl(
      'text' + (this.fieldArray.length - 1),
      new FormControl(1, Validators.required)
    )
  }
  deleteFieldValue(index) {
    this.fieldArray[index].isDeleted = true
  }
  disableDelete = () => {
    const activeCount = this.fieldArray.filter((entry, index) => {
      return !entry?.isDeleted
    })
    return activeCount?.length
  }
  increaseQuantity(value, i) {
    this.fieldArray[i].qty = value.toString()
  }
  decreaseQuantity(value, i) {
    this.fieldArray[i].qty = value.toString()
  }
  quantityEntry(value, i) {
    this.fieldArray[i].qty = value.toString()
  }

  uploadLineContent() {
    this.uploadArr = []
    this.fieldArray = this.fieldArray.filter((index) => !index.isDeleted)
    for (let i = 0; i < this.fieldArray.length; i++) {
      if (
        this.fieldArray[i].name == null ||
        this.fieldArray[i].name == '' ||
        this.fieldArray[i].name == !this.fieldArray[i].name
      ) {
        this.showError = true
        this.fieldArray[i].showError = this.showError
      } else {
        const obj = {
          productCode: this.fieldArray[i].name,
          quantity: this.fieldArray[i].qty,
          requestedShipDate: '',
        }
        this.uploadArr.push(obj)
      }
    }
    for (let j = 0; j < this.uploadArr.length; j++) {
      if (
        this.uploadArr[j].quantity == undefined ||
        this.uploadArr[j].quantity == null
      ) {
        this.uploadArr[j].quantity = '1'
      }
    }

    if (this.uploadArr.length == this.fieldArray.length) {
      this.bulkservice
        .getBulkCopyPasteList(this.uploadArr, this.userType)
        .subscribe((res) => {
          this.bulkservice.sendBulkOrderList(res)
          this.bulkservice.emitDate(false)
          this.router.navigate(['bulk-Table'])
        })
      this.uploadArr = []
    }
  }

  partNo(name, i) {
    if (name.length > 0) {
      this.fieldArray[i].showError = false
    }
  }
  partEntered() {
    this.showTextError = false
    this.incorrectNo = false
  }
  stopCount(e) {
    var enteredText = e
    var numberOfLineBreaks = (enteredText.match(/\n/g) || []).length
    var characterCount = enteredText.length + numberOfLineBreaks
    if (numberOfLineBreaks > 149) {
      this.disabledClass = true
      e.preventDefault()
      return false
    } else {
      this.disabledClass = false
    }
  }
}
